import { createSelector } from 'reselect';
export const getEcosystem = state => state.ecosystem;
const getEcosystemDetails = createSelector([getEcosystem], state => state.details);
export const getEcosystemDetailsData = createSelector([getEcosystemDetails], state => state.data);
export const getEcosystemDetailsStatus = createSelector([getEcosystemDetails], state => state.status);